import {buildAuthenticationHeaders, dashboardAxios} from './global';

const getTenDlcNumbers = (credentials) =>
    dashboardAxios.get(`/messages-10dlc/api/account/${credentials.accountId}/numbers`, {
      ...buildAuthenticationHeaders(credentials)
    });

export {
  getTenDlcNumbers
};
